import { useNavigate, Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';

import useFetchSites from '../hooks/useFetchSites';

import ListSite from '../components/ListSite';

import { formatCurrency } from '../utils/Format';

const SiteList = () => {
    const navigate = useNavigate();
    const { sites, fetchSites, loading, error } = useFetchSites();

    const didFetchRef = useRef(false);

    useEffect(() => {
        if (didFetchRef.current) return;
        didFetchRef.current = true;
        fetchSites();
    }, [fetchSites]);

    const handleRowDoubleClick = (event) => {
        const clickedRowData = event.rowData;
        const uuid = clickedRowData.UUID_;
        if (uuid) navigate(`/sites/${uuid}`);
    };

    const isLoading = loading || !didFetchRef.current;

    const siteCount = Array.isArray(sites) ? sites.length : 0;

    return (
<div className="h-screen box-border flex flex-col 
                pt-2 pb-6 px-4 
                lg:pt-4 lg:pb-10 lg:px-10">
            <div className="flex-1 min-h-0">
                <div className="gap-6 grid grid-cols-12 h-full">
                    <div className="gap-6 grid grid-cols-12 col-span-12 xxl:col-span-9 h-full">
                        <div className="col-span-12 flex flex-col min-h-0">

                            <div className="mb-3 w-full rounded-lg bg-gray-900/95 px-4 py-2 shadow-md sm:px-6 sm:py-3">
                                <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-center">
                                    <div className="space-y-2">
                                        <nav
                                            id="url"
                                            className="flex items-center gap-2 text-xs font-semibold text-gray-400 sm:text-sm"
                                        >
                                            <Link
                                                to="/sites"
                                                className="decoration-orange-600 transition duration-300 hover:-translate-y-[1px] hover:text-white hover:underline hover:underline-offset-2"
                                            >
                                                Sites
                                            </Link>
                                            <span className="cursor-default text-gray-500">/</span>
                                        </nav>

                                        <h1 className="text-xl font-semibold text-white sm:text-2xl">
                                            Liste des sites
                                        </h1>

                                        {/*} <div className="mt-1">
                                            {isLoading ? (
                                                <span className="inline-flex items-center gap-2 rounded-full bg-gray-700/60 px-4 py-1.5">
                                                    <span className="h-4 w-24 animate-pulse rounded-full bg-gray-500/60" />
                                                </span>
                                            ) : siteCount === 0 ? (
                                                <span className="inline-flex items-center gap-2 rounded-full bg-gray-700 px-4 py-1.5 text-xs font-medium text-gray-200">
                                                    <i className="fa-regular fa-circle-xmark text-red-300" />
                                                    Aucun site disponible
                                                </span>
                                            ) : (
                                                <span className="inline-flex items-center gap-2 rounded-full bg-gray-700 px-4 py-1.5 text-xs font-medium text-gray-100">
                                                    <i className="fa-regular fa-building text-orange-300" />
                                                    {siteCount} {siteCount > 1 ? "sites" : "site"}
                                                </span>
                                            )}
                                        </div>*/}
                                    </div>

                                    <div className="w-full md:w-auto">
                                        <Link
                                            to="/sites/create"
                                            className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-orange-600 px-6 py-2 text-sm font-semibold text-white shadow-md shadow-orange-700/20 transition duration-200 hover:bg-orange-500 focus:outline-none focus:ring-2 focus:ring-orange-700 focus:ring-offset-2 focus:ring-offset-gray-900 md:w-auto"
                                        >
                                            <i className="fa-solid fa-plus" />
                                            Ajouter un site
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className="flex-1 min-h-0">
                                <ListSite
                                    lstSites={sites}
                                    handleRowDoubleClick={handleRowDoubleClick}
                                    loading={loading}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>



    );
};

export default SiteList;

